// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import {Row, Col ,Pagination, Tabs, TabPane, Button, ButtonGroup} from 'element-ui'



import '../static/css/restcss.css'
import '../static/css/index.css'
import 'element-ui/lib/theme-chalk/display.css'



Vue.config.productionTip = false;
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Pagination.name, Pagination);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
Vue.component(Button.name, Button);
Vue.component(ButtonGroup.name, ButtonGroup);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
	i18n: i18n,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js